module.exports = "/assets/05112f36072d8d544b79acd8dbfcbe4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QA.png
// module id = 1744
// module chunks = 0